export default __webpack_public_path__ + "static/media/2A9FF376-D676-4211-8B9A-C39700139B52.d43d59ba.jpg";